import React from "react";
import strings from "translate/language";

const TableDataNotFound = ({ data = [] }) => {
    return data.length === 0 ? (
        <div className="text-center mt-4 mb-3">{strings.tableDataErr}</div>
    ) : null;
};
export default TableDataNotFound;
